function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

import React from 'react';
import PropTypes from 'prop-types';
import renderIf from '@signal/utils/renderIf';
import mutuallyExclusiveProps from '@signal/prop-types/mutuallyExclusiveProps';
import { Container, AvatarSkeleton, NameSkeleton, SubtitleSkeleton, LogoutButton } from './styles';
export function UserInfoSkeleton(_ref) {
  var showLogout = _ref.showLogout,
      showSubtitle = _ref.showSubtitle,
      short = _ref.short,
      rest = _objectWithoutProperties(_ref, ["showLogout", "showSubtitle", "short"]);

  var widthMultiplier = short ? 0.85 : 1;
  var nameWidth = 100 * widthMultiplier;
  var subtitleWidth = 80 * widthMultiplier;
  return /*#__PURE__*/React.createElement(Container, rest, /*#__PURE__*/React.createElement(AvatarSkeleton, null), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(NameSkeleton, {
    color: "skeletonDark",
    width: nameWidth
  }), renderIf(showSubtitle, function () {
    return /*#__PURE__*/React.createElement(SubtitleSkeleton, {
      width: subtitleWidth
    });
  }), renderIf(showLogout, function () {
    return /*#__PURE__*/React.createElement(LogoutButton, {
      disabled: true
    }, "Logout");
  })));
}
UserInfoSkeleton.propTypes = mutuallyExclusiveProps({
  showLogout: PropTypes.bool,
  showSubtitle: PropTypes.bool
});
export default UserInfoSkeleton;